import { SearchParams } from '@flowus/login/const';
import type { FC } from 'react';
import { Icon } from 'src/common/components/icon';
import { publicLink } from 'src/common/const';
import { FeatureFlags } from 'src/feature-flags';

interface Props {
  keyword?: string;
}
export const AiTip: FC<Props> = (props) => {
  if (!FeatureFlags.AI_TIP) {
    return null;
  }
  return (
    <div
      className="mt-2.5 flex items-center h-[54px] w-full border border-grey6 px-2.5 py-4 rounded-md cursor-pointer hover:bg-black_003"
      style={{
        boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.06)',
      }}
      onClick={() => {
        const params = new URLSearchParams();
        if (props.keyword) {
          params.append(SearchParams.defaultPrompt, props.keyword);
        }
        params.append(SearchParams.openAI, 'true');
        window.open(`${publicLink.helpCenter}?${params.toString()}`);
      }}
    >
      <Icon name={'MIcAiMiddleColor'} size="xxlarge" />
      <div className="ml-2 text-t2-medium">在帮助中心里问问AI</div>
    </div>
  );
};
